import type { RouteLocation, RouteLocationRaw, Router } from 'vue-router'
import { type App, inject } from 'vue'

export type AbsoluteUrlGenerator = (
    path: RouteLocation | string | RouteLocationRaw
) => URL

const key = '__plugin_absolute_url'

export function installAbsoluteUrl(
    app: App,
    host: string,
    scheme: string,
    router: Router
): AbsoluteUrlGenerator {
    const generator = createAbsoluteUrl(host, scheme, router)

    app.provide(key, generator)

    return generator
}

function createAbsoluteUrl(
    host: string,
    scheme: string,
    router: Router
): AbsoluteUrlGenerator {
    function pathToString(
        path: RouteLocation | string | RouteLocationRaw
    ): string {
        if (typeof path === 'string') {
            return path.replace(/^\/+/, '/')
        } else {
            if (!('fullPath' in path)) {
                return router.resolve(path).fullPath
            } else {
                return path.fullPath
            }
        }
    }

    return (path: RouteLocation | string | RouteLocationRaw) => {
        return new URL(pathToString(path), `${scheme}//${host}`)
    }
}

export function useAbsoluteUrl(): AbsoluteUrlGenerator {
    return inject(key) as AbsoluteUrlGenerator
}
